export default __webpack_public_path__ + "static/media/line02.13059757.jpg";